import { render, staticRenderFns } from "./OnLogin.vue?vue&type=template&id=680a7135&"
import script from "./OnLogin.vue?vue&type=script&lang=js&"
export * from "./OnLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports